import { employments } from './employments';
import { employmentAndJobProfile } from './employmentAndJobProfile';
import { employmentStatistics } from './employmentStatistics';
import { legacyEmployments } from './legacyEmployments';
import { salaryReviewAssessments } from './salaryReviewAssessments';
import { salaryReviewEmployments } from './salaryReviewEmployments';
import { involveDashboard } from './involveDashboard';
import { involveSalaryTypes } from './involveSalaryTypes';
import { statistics } from './statistics';

export const sectionManager = {
    employments,
    employmentAndJobProfile,
    employmentStatistics,
    legacyEmployments,
    salaryReviewAssessments,
    salaryReviewEmployments,
    involveDashboard,
    involveSalaryTypes,
    statistics,
};
